/* eslint-disable no-console */

import Vue from 'vue';

import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

import { SERVER_ENV as environment } from '@/config';

import { name, version } from '../../package.json';

import { DSN as dsn, ENVS } from '../config/sentry';

const shouldCapture = ENVS.includes(environment as string);

const sentryInit = function() {
  if (!shouldCapture) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`[Sentry]: won't capture errors in ${environment} environment.`);
    }

    return;
  }

  Sentry.init({
    Vue,
    dsn,
    environment,
    release: `${name}-${version}`,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    tracingOptions: {
      trackComponents: true,
    },
  });
};

sentryInit();
